/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-useless-escape: 0, no-var: 0 */
/* globals _, Backbone, mp, RISON */

_.namespace(`Backbone`, function() {
  'use strict';

  // from backbone.js
  var namedParam = /:\w+/g;
  var splatParam = /\*\w+/g;
  var escapeRegExp = /[-[\]{}()+.,\\^$|#\s]/g;

  var risonParam = /:rison/g;

  var ViewRouter = Backbone.Router.extend({

    constructor: function constructor({disablePersistence=false} = {}) {
      this.disablePersistence = disablePersistence;
      if (mp.report && mp.report.globals && mp.report.globals.persistence && !this.disablePersistence ) {
        this._load_persistence();
      }

      Backbone.Router.prototype.constructor.apply(this, arguments);
    },

    navigate(fragment, options) {
      if (this.persistence && !this.disablePersistence && this.allow_persistence(fragment, options)) {
        this.persistence.run(null, `#` + fragment);
      }
      Backbone.Router.prototype.navigate.apply(this, arguments);
    },

    route(route, name, callback) {
      var cb;
      if (! _.isUndefined(callback)) {
        cb = function() {
          var route_data = callback.apply(this, arguments);
          if (route_data) {
            this._change_page(name, route_data);
          }
        };
      }
      return Backbone.Router.prototype.route.call(this, route, name, cb);
    },

    allow_persistence(fragment, options) {
      return true; // Persist all fragments by default
    },

    _load_persistence() {
      this.persistence = mp.report.globals.persistence;

      // load a saved hash from persistence if there is no hash
      if (!document.location.hash && window.location.href.substr(-1) !== `#`) {
        var hash = this.persistence.path_to_hash(this.persistence.get_pathname());
        window.location.hash = hash;
      }
    },

    _change_page(name, route_data, non_rison) {
      // error out if session or render_target are undefined
      // we do this here so that you can use ViewRouter as an
      // inline replacement to regular Backbone.Router
      if (!this.session) { throw `Must define 'session' variable on ViewRouter`; }
      if (!this.render_target) { throw `Must define 'render_target' variable on ViewRouter`; }

      // deconstruct the current view
      if (this.current_view) { this.current_view.close(); }

      // update session variables
      this.session.set(_.extend({page: name}, route_data.session));

      // construct new view
      this.current_view = new route_data.view();
      this.render_target.html(this.current_view.el);

      // load rison support
      this._load_rison(route_data.rison);

      this.current_view.trigger(`ready`);
    },

    _load_rison(rison) {
      // load rison
      if (rison) {
        var params = this._decode_rison(rison);
        if (params) {
          this.current_view.update_params(params);
        }
      }

      this.current_view.on(`serialize_params`, function(prefix, params) {
        var rison = this._encode_rison(params);
        this.navigate(prefix + `/` + rison);
      }, this);
    },

    _decode_rison(rison) {
      if (!rison) { return {}; }
      return RISON.urldecode(_.sprintf(`(%s)`, rison));
    },

    _encode_rison(params) {
      const encodeAll = mp.report.globals.report_name === "explore";
      var rison = RISON.urlencode(params, null, encodeAll);
      return rison.substring(1, rison.length - 1); // remove leading and trailing parens
    },

    _routeToRegExp(route) {
      route = route.replace(escapeRegExp, `\\$&`)
        .replace(risonParam, `(?:\/([^\/]+))?`)
        .replace(namedParam, `([^\/]+)`)
        .replace(splatParam, `(.*?)`);
      return new RegExp(`^` + route + `$`);
    },
  });

  return {
    ViewRouter,
  };
});

}.call(window));